<template>
  <el-col :span="span" class="hl-descriptions-item">
    <span class="label" :style="{ width: labelWidth, textAlign: labelAlign }">
      {{ label }}{{ label ? labelSuffix : '' }}
    </span>
    <span class="content" :style="contentStyle"><slot /></span>
  </el-col>
</template>

<script>
export default {
  props: {
    span: {
      type: Number,
      default: 12
    },
    label: {
      type: String
    },
    labelWidth: {
      type: String,
      default: '100px'
    },
    labelAlign: {
      type: String,
      default: 'right'
    },
    contentStyle: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelSuffix: ': '
    }
  }
}
</script>

<style lang="scss" scoped>
.hl-descriptions-item {
  font-size: 14px;
  margin-bottom: 16px;
  display: flex;
  line-height: 22px;
  .label {
    font-size: 14px;
    color: #999999;
    margin-right: 8px;
    flex-shrink: 0;
  }
  .content {
    color: #333333;
    flex: 1;
  }
}
</style>
